var SavesLoadingView = Marionette.ItemView.extend({
    tagName: "nf-section",
    template: "#tmpl-nf-saves-loading",
    el: ".form-save-loading"
});
